import { branch, renderComponent } from 'recompose';

import { LogoWrapper, NoLinkLogoWrapper } from './Wrapper';
import { isLink } from './helpers';

export default branch(isLink, renderComponent(LogoWrapper))(NoLinkLogoWrapper);
